import { render, staticRenderFns } from "./yic.vue?vue&type=template&id=c0476458&scoped=true"
import script from "./yic.vue?vue&type=script&lang=js"
export * from "./yic.vue?vue&type=script&lang=js"
import style0 from "./yic.vue?vue&type=style&index=0&id=c0476458&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0476458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0476458')) {
      api.createRecord('c0476458', component.options)
    } else {
      api.reload('c0476458', component.options)
    }
    module.hot.accept("./yic.vue?vue&type=template&id=c0476458&scoped=true", function () {
      api.rerender('c0476458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/yic.vue"
export default component.exports